const list = require('./list')
const generator = require('./generator')
const original = require('./original')

module.exports = [
  original,
  ...list.map(generator)
]
